import { render, staticRenderFns } from "./DiyPackage.vue?vue&type=template&id=7e601843&scoped=true"
import script from "./DiyPackage.vue?vue&type=script&lang=js"
export * from "./DiyPackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e601843",
  null
  
)

export default component.exports